'use client';
import { RESPONSIVE_MARGIN } from '@/functions/createTheme';
import { relativePath } from '@/functions/redirectToRelativePath';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { Fragment } from 'react';
import { EventCard } from '../EventCardList/EventCard';

type Props = {
  categoryId: number;
  events: ImEventDto[];
  customerSetting: CustomerSetting;
};

export const CategoryEventList: React.FC<Props> = ({
  categoryId,
  events,
  customerSetting
}) => {
  const theme = useTheme();
  const category = customerSetting.categories.find((c) => c.id === categoryId);

  return category ? (
    <Box sx={{ mt: { xs: 8, sm: 12 }, mb: RESPONSIVE_MARGIN }}>
      <Box sx={{ my: 1 }}>
        <Typography
          component="h2"
          variant="h5"
          sx={{
            fontSize: {
              xs: theme.typography.h6.fontSize,
              sm: theme.typography.h5.fontSize
            }
          }}
        >
          {category.name}のイベント
        </Typography>
      </Box>
      <Divider />
      {events.map((imEvent) => {
        return (
          <Fragment key={imEvent.id}>
            <EventCard imEvent={imEvent} customerSetting={customerSetting} />
            <Divider />
          </Fragment>
        );
      })}
      <Box
        sx={{
          my: RESPONSIVE_MARGIN,
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Button
          variant="contained"
          href={relativePath(
            `/list/?category=${category.id}#events`,
            customerSetting.domain
          )}
          sx={{ borderRadius: 6, minWidth: 150 }}
        >
          もっと見る
        </Button>
      </Box>
    </Box>
  ) : null;
};
